<template>
  <div id="app">
    <div
      v-if="!isAuth"
      class="container-fluid position-relative"
    >
      <lang-switch
        class="d-inline-block"
        add-class="non-auth"
      />
    </div>
    <transition
      leave-active-class="fadeOut"
      enter-active-class="fadeIn"
      @before-leave="makeAbsolute"
      @enter-leave="makeAbsolute"
    >
      <non-auth-layout
        v-if="!isAuth"
        style="animation-duration: 0.5s"
      />
      <auth-layout
        v-if="isAuth"
        style="animation-duration: 0.5s"
      />
    </transition>
  </div>
</template>

<script>
import LangSwitch from './components/LangSwitch.vue'
import { localize } from 'vee-validate'

import AuthLayout from './views/app-partials/AuthLayout.vue'
import NonAuthLayout from './views/app-partials/NonAuthLayout.vue'

import auth from './middleware/auth'

export default {
  components: {
    'lang-switch': LangSwitch,
    'auth-layout': AuthLayout,
    'non-auth-layout': NonAuthLayout
  },
  computed: {
    lang () {
      return this.$store.state.lang
    },
    isAuth () {
      return this.$store.getters['auth/isAuthenticated']
    }
  },
  watch: {
    lang (newValue, oldValue) {
      this.$i18n.locale = newValue
      localize(newValue) // for validation rules
    },
    isAuth (newValue, oldValue) {
      const needAuth = this.$router.currentRoute.meta.middleware.includes(auth)

      if (newValue === false && needAuth) {
        // if is not logout - display token error message
        if (!this.$store.state.auth.logoutInProgress) {
          this.$flash.error(this.$t('Your session has expired. You must log in again.'))
        }

        this.$router.push({ name: 'login' }).catch(() => {})
      }
    }
  },
  created () {
    this.$store.dispatch('loadSystemLangs').then(() => {}).catch((e) => {
      this.$flash.error(this.$t('Unable to load system langs!'))
    })
    if (this.$workbox) {
      this.$workbox.addEventListener('waiting', () => {
        this.pwaUpdate()
      })
    }
  },
  beforeMount () {
    this.$i18n.locale = this.lang
  },
  methods: {
    async pwaUpdate () {
      await this.$workbox.messageSW({ type: 'SKIP_WAITING' })
    }
  }
}
</script>

<style lang="scss">
  @import './assets/scss/app.scss';
</style>
